import React from "react";

import styleClasses from "../Home.module.scss";
import {
  CAREERS_APPLY_ROUTE_URL,
  REACT_APP_CLOUD_FRONT,
  ROUTE_OUR_KITCHEN,
} from "../../../constants";
import { string } from "yup";
import { useHistory } from "react-router";

interface FreeItemProps {
  headingText: string;
  isButtonShow?: boolean;
  homeFreeItemStyles?: string;
  width?: number;
  isDescriptionShow?: boolean;
  buttonText?: string;
  btnRoute?: string;
  content?:string;
  headingStyle?:string;
}
const FreeItem: React.FC<FreeItemProps> = ({
  headingText,
  isButtonShow,
  homeFreeItemStyles,
  width,
  isDescriptionShow,
  buttonText,
  btnRoute,
  content
}) => {
  const history = useHistory();
  return (
    <>
      <div className={`${styleClasses.section_last} ${homeFreeItemStyles}`}>
        <img
          src={`${REACT_APP_CLOUD_FRONT}/Items/home_page_loyalty_images/section/7/strawb.png`}
          className={`${styleClasses.section_last_img}`}
          alt="strawberry"
          width={width}
        />
        <h1 className="f-s45 f-sm-s18 mt-0 mt-md-4 text-uppercase clr-dark-blue">
          {headingText}
        </h1>
        {isDescriptionShow && (
          <p className="f-s20 f-w4 clr-dark-grey pt-2 f-sm-s16 px-2 px-md-0 font-Trade-regular">
            We prioritize our people because they are the heart of what we do.
            Our company’s core values enable <br /> our team members to Nourish
            The Good Life both in and out of the kitchen.
          </p>
        )}
        <p className="f-s20 f-w4 clr-dark-grey pt-2 f-sm-s16 px-2 px-md-0 font-Trade-regular">
           {content}
        </p>
        {isButtonShow &&
          (btnRoute === ROUTE_OUR_KITCHEN ? (
            <button
              className="btn btn-large mt-md-5 mt-3"
              style={{ maxWidth: "fit-content", minWidth: "fit-content" }}
              onClick={() => {
                history.push(btnRoute);
              }}
            >
              {buttonText}
            </button>
          ) : (
            <a
              className="btn btn-large mt-md-5 mt-3"
              style={{ maxWidth: "fit-content", minWidth: "fit-content" }}
              href={CAREERS_APPLY_ROUTE_URL}
              target="_blannk"
            >
              {buttonText}
            </a>
          ))}
      </div>
    </>
  );
};

export default FreeItem;
